import { m8API } from 'services/production/m8';

export const signOut = async () => {
  await m8API.auth.logout();
};
